<template>
  <v-card class="mb-8 tableExclusiones">
    <v-card-title primary-title class="py-2">
      <v-toolbar-title>{{ $t("view.bases.base.fragment.exclusiones") }}</v-toolbar-title>
      <v-spacer />
      <v-btn icon style="margin: 0" @click="view.elem.datatable.visible = !view.elem.datatable.visible">
        <v-icon>{{ view.elem.datatable.visible ? "keyboard_arrow_down" : "keyboard_arrow_up" }}</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text v-show="view.elem.datatable.visible" class="py-0">
      <v-layout row wrap>
        <v-flex md12>
          <v-data-table
            ref="dataTableExclusiones"
            item-key="clave"
            class="exclusiones dataTable"
            sort-by="clave"
            :sort-desc="true"
            :headers="view.elem.datatable.headers"
            :items="view.elem.datatable.data"
            :loading="view.elem.datatable.loading"
            :footer-props="view.elem.datatable.footerprops"
            :must-sort="true"
            :server-items-length="view.elem.datatable.total"
            :options.sync="options">
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
import BaseAPI from "@/services/bases/base";
import transform from "@/helpers/server-side-datatable";
import tippy from "tippy.js";

export default {
  name: "ExclusionesModal"
  , data() {
    return {
      titleModal: this.$t("view.commons.detail")
      , options: {}
      , filtros: {}
      , view: {
        elem: {
          datatable: {
            visible: true
            , loading: false
            , data: []
            , total: 0
            , footerprops: { showFirstLastPage: true, "items-per-page-options": [10, 25, 50, 100] }
            , headers: [
              { text: this.$t("view.bases.base.exclusiones.clave"), align: "center", sortable: true, class: "tableHeader", value: "clave" }
              , { text: this.$t("view.bases.base.exclusiones.campana"), align: "center", sortable: true, class: "tableHeader", value: "campana" }
              , { text: this.$t("view.bases.base.exclusiones.se"), align: "center", sortable: true, class: "tableHeader", value: "se" }
              , { text: this.$t("view.bases.base.exclusiones.status"), align: "left", sortable: true, class: "tableHeader", value: "status" }
              , { text: this.$t("view.bases.base.exclusiones.vendor"), align: "left", sortable: true, class: "tableHeader", value: "vendor", width: "200px" }
            ]
          }
        }
      }
    };
  }
  , watch: {
    options: {
      handler() {
        this.load();
      }
      , deep: true
    }
    , search: {
      handler() {
        this.options.page = 1;
        this.load();
      }
      , deep: true
    }
  }
  , updated() {
    this.$nextTick(function () {
      tippy(".btn_tippy", { arrow: true, arrowType: "round", animation: "scale" });
    });
  }
  , methods: {
    open(clave) {
      this.filtros = {};
      this.filtros.base = clave;
      this.options = { page: 1, itemsPerPage: 10, sortBy: ["clave"], sortDesc: [true], groupBy: [], groupDesc: [], mustSort: true, multiSort: false };
      if (clave) this.load();
    }
    , prepareData() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      let serverSideData = {};
      serverSideData.draw = "0";
      serverSideData.filters = JSON.stringify(this.filtros);
      serverSideData.start = page;
      serverSideData.length = itemsPerPage;
      serverSideData.search = { value: this.search ? this.search : "", regex: false };
      serverSideData.order = { column: sortBy, dir: sortDesc };
      serverSideData.columns = this.view.elem.datatable.headers;
      return transform.transformServerSideRequest(serverSideData);
    }
    , async load() {
      if (!this.filtros || this.filtros == {}) return false;
      this.view.elem.datatable.loading = true;

      const serverSideDataT = this.prepareData();
      const response = await BaseAPI.listExclusiones(serverSideDataT);
      const { data, recordsTotal } = response.data;

      this.view.elem.datatable.data = data;
      this.view.elem.datatable.total = Number(recordsTotal);

      this.view.elem.datatable.loading = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/bases/base/DataTableExclusiones.vue